import StickyNav from './components/StickyNav';
import Hero from './components/Hero';
import About from './components/About';
import Divisions from './components/Divisions';
import WhyUs from './components/WhyUs';
import OurStory from './components/OurStory';
import Milestones from './components/Milestones';
import Leadership from './components/Leadership';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import './App.css';

// The whole site lives at "/" — every section is a #anchor on that one
// page, not a separate route. Any other path (typos, guessed URLs, old
// links) isn't a real page, so it gets the 404 screen instead of silently
// rendering the homepage.
const isKnownPath = window.location.pathname === '/' || window.location.pathname === '/index.html';

function App() {
  if (!isKnownPath) {
    return <NotFound />;
  }

  return (
    <div className="App">
      <StickyNav />
      <Hero />
      <About />
      <Divisions />
      <WhyUs />
      <OurStory />
      <Milestones />
      <Leadership />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
